<script lang="ts">
  type Props = {
    checked?: boolean
    label: string
  }

  let {
    checked = $bindable(),
    label,
  }: Props = $props()
</script>

<button
  class="switch-container"
  class:checked
  aria-label={label}
  onclick={() => {
    checked = !checked
  }}
>
  <div class="switch"></div>
</button>

<style lang="scss">
  .switch-container {
    width: 2.25rem;
    border: 1px solid var(--switch-border);
    background: var(--background);
    padding: 0.1rem;
    border-radius: 2rem;
    cursor: pointer;
    transition: all .3s ease;

    .switch {
      height: 1rem;
      width: 1rem;
      border-radius: 1rem;
      background: var(--switch-foreground);
      transition: all .3s ease;
    }
    &.checked {
      border-color: var(--switch-border-active);

      .switch {
        margin-left: 0.9rem;
        background: var(--switch-foreground-active);
      }
    }
  }
</style>
